import { Box, Container, Typography } from '@mui/material';
import { linkType } from '@utils/types';
import theme from 'src/style-system/theme';
import Link from 'next/link';

interface OrderFlowFooterProps {
  footerContent: linkType[];
  isStickyButtonAtBottom?: boolean;
}

const OrderFlowFooter = ({
  footerContent,
  isStickyButtonAtBottom,
}: OrderFlowFooterProps) => {
  return (
    <>
      <Box bgcolor="garamMasala.dark">
        <Container
          disableGutters
          sx={{
            maxWidth: 'sm',
            padding: { xs: '30px 15px', sm: '30px 50px' },
            [theme.breakpoints.up('md')]: {
              maxWidth: 'xl',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            },
          }}
        >
          <Box
            sx={{
              [theme.breakpoints.down('md')]: {
                display: 'none',
              },
            }}
          >
            <Typography variant="body2" color="turmeric.main">
              &copy; 2022 The Cumin Club
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              columnGap: '15px',
              [theme.breakpoints.down('sm')]: {
                columnGap: '5px',
              },
              [theme.breakpoints.up('lg')]: {
                width: '40%',
              },
            }}
          >
            {footerContent.map((item) => (
              <Link href={item.link} key={item.id}>
                <a target="_blank">
                  <Typography
                    variant="body2"
                    color="turmeric.main"
                    key={item.id}
                    sx={{
                      cursor: 'pointer',
                    }}
                  >
                    {item.value}
                  </Typography>
                </a>
              </Link>
            ))}
          </Box>
        </Container>
      </Box>
      <Box
        bgcolor="garamMasala.main"
        sx={{
          marginBottom: isStickyButtonAtBottom ? '72px' : '0px',
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
        }}
      >
        <Container maxWidth="sm" disableGutters>
          <Box
            sx={{
              padding: { xs: '15px 25px', sm: '15px 50px' },
            }}
          >
            <Typography variant="body2" color="whitePepper.main">
              &copy; 2022 The Cumin Club
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default OrderFlowFooter;
